import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { DashboardComponent } from "./dashboard/dashboard.component";
import { CalendarComponent } from "./calendar/calendar.component";
import { ChatComponent } from "./chat/chat.component";
import { KanbanComponent } from "./kanban/kanban.component";
import { VehiclesComponent } from "./customer-mgmt/vehicle/vehicles/vehicles.component";
import { TripsComponent } from "./customer-mgmt/trips/trips.component";
import { DrivingAlertsComponent } from "./customer-mgmt/vehicle/driving-alerts/driving-alerts.component";
import { VehicleTroubleCodesComponent } from "./customer-mgmt/vehicle/vehicle-trouble-codes/vehicle-trouble-codes.component";
import { AlertCustomersComponent } from "./customer-mgmt/alert-customers/alert-customers.component";
import { RemindersUsersComponent } from "./customer-mgmt/reminders-users/reminders-users.component";
import { TeamUsersComponent } from "./customer-mgmt/team-users/team-users.component";
import { FaqComponent } from "./customer-mgmt/faq/faq.component";
import { DrivingSchoolProfileComponent } from "./driving-school/driving-school-profile/driving-school-profile.component";
import { DrivingSchoolMyEarningsComponent } from "./driving-school/driving-school-my-earnings/driving-school-my-earnings.component";
import { DrivingSchoolStudentsComponent } from "./driving-school/driving-school-students/driving-school-students.component";
import { DrivingSchoolDashboardComponent } from "./driving-school/driving-school-dashboard/driving-school-dashboard.component";
import { RoleGuard } from "../core/guards/role.guard";
import { TripsMapComponent } from "./customer-mgmt/trips/trips-map/trips-map.component";
import { MapDashboardComponent } from "./fleet/map-dashboard/map-dashboard.component";
import { DriverRiskAnalysisComponent } from "./fleet/driver-risk-analysis/driver-risk-analysis.component";
import { DrivingAlertsAnalysisComponent } from "./fleet/driver-risk-analysis/driving-alerts-analysis/driving-alerts-analysis.component";
import { AllVehiclesComponent } from "./all-vehicles/all-vehicles.component";
import { FuelExpensesComponent } from "./fleet/fuel-expenses/fuel-expenses.component";

const routes: Routes = [
  { path: "", component: DashboardComponent, canActivate: [RoleGuard] },
  { path: "calendar", component: CalendarComponent },
  { path: "chat", component: ChatComponent },
  { path: "kanban-board", component: KanbanComponent },
  {
    path: "ecommerce",
    loadChildren: () =>
      import("./ecommerce/ecommerce.module").then((m) => m.EcommerceModule),
  },
  {
    path: "email",
    loadChildren: () =>
      import("./email/email.module").then((m) => m.EmailModule),
  },
  {
    path: "pages",
    loadChildren: () =>
      import("./utility/utility.module").then((m) => m.UtilityModule),
  },
  {
    path: "ui",
    loadChildren: () => import("./ui/ui.module").then((m) => m.UIModule),
  },
  {
    path: "icons",
    loadChildren: () =>
      import("./icons/icons.module").then((m) => m.IconsModule),
  },
  {
    path: "charts",
    loadChildren: () =>
      import("./chart/chart.module").then((m) => m.ChartModule),
  },
  {
    path: "form",
    loadChildren: () => import("./form/form.module").then((m) => m.FormModule),
  },
  {
    path: "tables",
    loadChildren: () =>
      import("./tables/tables.module").then((m) => m.TablesModule),
  },
  {
    path: "maps",
    loadChildren: () => import("./maps/maps.module").then((m) => m.MapsModule),
  },
  {
    path: "customers/:id/vehicles",
    component: VehiclesComponent,
  },
  {
    path: "vehicles",
    component: AllVehiclesComponent,
  },
  {
    path: "customers/:id/risk-analysis",
    component: DriverRiskAnalysisComponent,
  },
  {
    path: "customers/:id/fuel-expenses",
    component: FuelExpensesComponent,
  },
  {
    path: "customers/:id/driving-alerts-analysis",
    component: DrivingAlertsAnalysisComponent,
  },
  {
    path: "customers/:id/vehicles/:vehicleId/trouble-codes",
    component: VehicleTroubleCodesComponent,
  },
  {
    path: "customers/:id/trips",
    component: TripsComponent,
  },
  {
    path: "customers/:id/trips/map/:tripId",
    component: TripsMapComponent,
  },
  {
    path: "customers/driving-alerts",
    component: DrivingAlertsComponent,
  },
  {
    path: "alert-customers",
    component: AlertCustomersComponent,
  },
  {
    path: "reminder-customers",
    component: RemindersUsersComponent,
  },
  {
    path: "map-dashboard",
    component: MapDashboardComponent,
    canActivate: [RoleGuard],
    data: {
      role: "fleet",
    },
  },
  {
    path: "team",
    component: TeamUsersComponent,
  },
  {
    path: "faq",
    component: FaqComponent,
  },
  {
    path: "driving-school",
    children: [
      {
        path: "",
        component: DrivingSchoolDashboardComponent,
      },
      {
        path: "profile",
        component: DrivingSchoolProfileComponent,
      },
      {
        path: "my-earnings",
        component: DrivingSchoolMyEarningsComponent,
      },
      {
        path: "students",
        component: DrivingSchoolStudentsComponent,
      },
      {
        path: "students/:id/vehicles",
        component: VehiclesComponent,
      },
      {
        path: "students/:id/vehicles/:vehicleId/trouble-codes",
        component: VehicleTroubleCodesComponent,
      },
      {
        path: "students/:id/trips",
        component: TripsComponent,
      },
      {
        path: "students/driving-alerts",
        component: DrivingAlertsComponent,
      },
      {
        path: "alert-customers",
        component: AlertCustomersComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
